import Link from 'next/link'

interface BlogLinkProps {
  slug: string,
  children: React.ReactNode,
}

const BlogLink = ({ slug, children }: BlogLinkProps) => {
  const href = slug === '/' ? '/blog' : `/blog/posts/${slug}`
  return <Link href={href}>{ children }</Link>
}

export default BlogLink
